(function() {
  'use strict';

  const root = document.querySelector('[data-fsb-search]');
  if (!root) return;

  const form = root.querySelector('[data-fsb-search-form]');
  const input = root.querySelector('[data-fsb-search-input]');
  const clearBtn = root.querySelector('[data-fsb-search-clear]');
  const dropdown = root.querySelector('[data-fsb-search-dropdown]');
  const overlay = root.querySelector('[data-fsb-search-overlay]');
  const panelIdle = root.querySelector('[data-fsb-search-panel="idle"]');
  const panelResults = root.querySelector('[data-fsb-search-panel="results"]');
  const loading = root.querySelector('[data-fsb-loading]');

  const recentWrap = root.querySelector('[data-fsb-recent-wrap]');
  const recentEl = root.querySelector('[data-fsb-recent]');
  const queriesWrap = root.querySelector('[data-fsb-queries-wrap]');
  const queriesEl = root.querySelector('[data-fsb-queries]');
  const productsWrap = root.querySelector('[data-fsb-products-wrap]');
  const productsEl = root.querySelector('[data-fsb-products]');
  const collectionsWrap = root.querySelector('[data-fsb-collections-wrap]');
  const collectionsEl = root.querySelector('[data-fsb-collections]');
  const viewAll = root.querySelector('[data-fsb-view-all]');
  const viewAllLink = root.querySelector('[data-fsb-view-all-link]');
  const emptyEl = root.querySelector('[data-fsb-empty]');

  const RECENT_KEY = 'fsb_recent_search';
  const RECENT_MAX = 6;
  const DEBOUNCE_MS = 220;
  const SEARCH_TIMEOUT_MS = 6000;
  const ROTATE_MS = parseInt(root.dataset.rotateSpeed, 10) || 2500;


  /* ---------- True-fixed sticky: detach on scroll past natural position, ----------
     reattach on scroll back. Uses a spacer div to prevent layout jump.
     Computes header offset from whatever is already pinned (theme header,
     store-messages, etc.) so it slides in just below the existing sticky chain. */
  function setupStickyBehavior() {
    if (root.getAttribute('data-sticky') !== 'true') return;

    var placeholder = document.createElement('div');
    placeholder.className = 'fsb-search-placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.style.cssText = 'display:none;width:100%;';
    root.parentNode.insertBefore(placeholder, root);

    var stuck = false;
    var naturalTop = 0;

    function getHeaderOffset() {
      var candidates = document.querySelectorAll(
        '.pageheader--sticky, .store-messages, .head-not-bar, [data-section-type="header"]'
      );
      var maxBottom = 0;
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el === root || root.contains(el) || el.contains(root)) continue;
        var rect = el.getBoundingClientRect();
        if (rect.top <= 3 && rect.bottom > maxBottom && rect.height > 0) {
          maxBottom = rect.bottom;
        }
      }
      return maxBottom;
    }

    function measure() {
      if (stuck) return;
      var rect = root.getBoundingClientRect();
      naturalTop = rect.top + window.pageYOffset;
      placeholder.style.height = rect.height + 'px';
    }

    function update() {
      var headerOffset = getHeaderOffset();
      var scrollY = window.pageYOffset;
      var threshold = naturalTop - headerOffset;

      if (!stuck && scrollY > threshold) {
        stuck = true;
        placeholder.style.display = 'block';
        root.classList.add('fsb-search--stuck');
      } else if (stuck && scrollY <= threshold) {
        stuck = false;
        placeholder.style.display = 'none';
        root.classList.remove('fsb-search--stuck');
        root.style.top = '';
      }
      if (stuck) {
        root.style.top = headerOffset + 'px';
      }
    }

    measure();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function() {
      if (stuck) {
        stuck = false;
        placeholder.style.display = 'none';
        root.classList.remove('fsb-search--stuck');
        root.style.top = '';
      }
      setTimeout(function() { measure(); update(); }, 50);
    });
  }
  setupStickyBehavior();

  /* ---------- Rotating placeholder ---------- */
  const placeholders = ((window.FSB_SEARCH && window.FSB_SEARCH.placeholders) || '')
    .split('\n')
    .map(s => s.trim())
    .filter(Boolean);

  if (placeholders.length > 0) {
    let idx = 0;
    input.setAttribute('placeholder', 'Search for "' + placeholders[0] + '"');
    setInterval(() => {
      if (document.activeElement === input && input.value) return;
      idx = (idx + 1) % placeholders.length;
      input.classList.add('is-rotating');
      setTimeout(() => {
        input.setAttribute('placeholder', 'Search for "' + placeholders[idx] + '"');
        input.classList.remove('is-rotating');
      }, 220);
    }, ROTATE_MS);
  }

  /* ---------- Recent searches ---------- */
  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
    } catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q || q.length < 2) return;
    let list = getRecent().filter(x => x.toLowerCase() !== q.toLowerCase());
    list.unshift(q);
    list = list.slice(0, RECENT_MAX);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function removeRecent(q) {
    const list = getRecent().filter(x => x !== q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    renderRecent();
  }
  function renderRecent() {
    const list = getRecent();
    if (!list.length) { recentWrap.hidden = true; return; }
    recentWrap.hidden = false;
    recentEl.innerHTML = list.map(q => `
      <span class="fsb-search__pill fsb-search__pill--recent">
        <a href="/search?q=${encodeURIComponent(q)}&type=product" style="color:inherit;text-decoration:none;">${escapeHtml(q)}</a>
        <button type="button" class="fsb-search__pill-x" aria-label="Remove" data-remove="${escapeHtml(q)}">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6 L18 18 M18 6 L6 18"/></svg>
        </button>
      </span>
    `).join('');
    recentEl.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        removeRecent(btn.dataset.remove);
      });
    });
  }

  /* ---------- Open / close ---------- */
  function openDropdown() {
    dropdown.hidden = false;
    overlay.hidden = false;
    document.body.classList.add('fsb-search-open');
    renderRecent();
    showPanel(input.value.trim() ? 'results' : 'idle');
  }
  function closeDropdown() {
    dropdown.hidden = true;
    overlay.hidden = true;
    document.body.classList.remove('fsb-search-open');
    // Clear any spinner and cancel an in-flight search so a stale loader
    // can't reappear when the dropdown is reopened.
    loading.hidden = true;
    cancelActiveFetch();
  }
  function showPanel(which) {
    if (which === 'idle') {
      panelIdle.hidden = false;
      panelResults.hidden = true;
    } else {
      panelIdle.hidden = true;
      panelResults.hidden = false;
    }
  }

  input.addEventListener('focus', openDropdown);
  overlay.addEventListener('click', () => { closeDropdown(); input.blur(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !dropdown.hidden) { closeDropdown(); input.blur(); }
  });

  /* ---------- Clear ---------- */
  function syncClear() {
    clearBtn.hidden = !input.value;
  }
  input.addEventListener('input', syncClear);
  clearBtn.addEventListener('click', () => {
    input.value = '';
    syncClear();
    showPanel('idle');
    input.focus();
  });

  /* ---------- Predictive search ---------- */
  let debounceTimer;
  let activeFetch;
  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debounceTimer);
    if (!q) { showPanel('idle'); return; }
    debounceTimer = setTimeout(() => runSearch(q), DEBOUNCE_MS);
  });

  // Mark the current request as superseded, abort its socket, and clear its
  // watchdog timer. Used when a new search starts or the dropdown closes.
  function cancelActiveFetch() {
    if (!activeFetch) return;
    activeFetch.aborted = true;
    if (activeFetch.controller) { try { activeFetch.controller.abort(); } catch (e) {} }
    if (activeFetch.timeoutId) clearTimeout(activeFetch.timeoutId);
  }

  function runSearch(q) {
    showPanel('results');
    loading.hidden = false;
    cancelActiveFetch();

    const controller = ('AbortController' in window) ? new AbortController() : null;
    const thisFetch = { aborted: false, controller: controller, timeoutId: null };
    activeFetch = thisFetch;

    // Watchdog: if the request stalls without resolving or rejecting — e.g. a
    // 5G/4G handoff drops the socket silently — force the spinner off so the
    // circular loader can never stay stuck on screen.
    thisFetch.timeoutId = setTimeout(() => {
      thisFetch.aborted = true;
      if (controller) { try { controller.abort(); } catch (e) {} }
      loading.hidden = true;
    }, SEARCH_TIMEOUT_MS);

    const url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,query'
      + '&resources[limit]=6'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,vendor,tag';

    fetch(url, { headers: { 'Accept': 'application/json' }, signal: controller ? controller.signal : undefined })
      .then(r => r.json())
      .then(data => {
        if (thisFetch.aborted) return;
        renderResults(data.resources && data.resources.results || {}, q);
      })
      .catch(() => { /* network error, abort, or bad JSON — spinner cleared in finally */ })
      .finally(() => {
        clearTimeout(thisFetch.timeoutId);
        if (!thisFetch.aborted) loading.hidden = true;
      });
  }

  function renderResults(r, q) {
    const products = r.products || [];
    const collections = r.collections || [];
    const queries = r.queries || [];

    // Queries
    if (queries.length) {
      queriesEl.innerHTML = queries.slice(0, 4).map(item => {
        const text = item.text || item.title || '';
        return `<a href="/search?q=${encodeURIComponent(text)}&type=product">${escapeHtml(text)}</a>`;
      }).join('');
      queriesWrap.hidden = false;
    } else queriesWrap.hidden = true;

    // Products
    if (products.length) {
      productsEl.innerHTML = products.slice(0, 6).map(p => {
        const img = p.featured_image && (p.featured_image.url || p.image) || p.image || '';
        const price = p.price ? formatMoney(p.price) : '';
        return `
          <a class="fsb-search__product" href="${p.url}">
            <div class="fsb-search__product-img">${img ? `<img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy" width="48" height="48">` : ''}</div>
            <div class="fsb-search__product-meta">
              <div class="fsb-search__product-title">${escapeHtml(p.title)}</div>
              <div class="fsb-search__product-price">${price}</div>
            </div>
          </a>
        `;
      }).join('');
      productsWrap.hidden = false;
    } else productsWrap.hidden = true;

    // Collections
    if (collections.length) {
      collectionsEl.innerHTML = collections.slice(0, 6).map(c =>
        `<a href="${c.url}">${escapeHtml(c.title)}</a>`
      ).join('');
      collectionsWrap.hidden = false;
    } else collectionsWrap.hidden = true;

    // View all + empty
    const hasAny = products.length || collections.length || queries.length;
    if (hasAny) {
      viewAll.hidden = false;
      viewAllLink.setAttribute('href', '/search?q=' + encodeURIComponent(q) + '&type=product');
      emptyEl.hidden = true;
    } else {
      viewAll.hidden = true;
      emptyEl.hidden = false;
    }
  }

  /* ---------- Submit ---------- */
  form.addEventListener('submit', (e) => {
    const q = input.value.trim();
    if (!q) { e.preventDefault(); return; }
    saveRecent(q);
  });

  /* ---------- Keyboard nav ---------- */
  let activeIdx = -1;
  input.addEventListener('keydown', (e) => {
    if (dropdown.hidden) return;
    const items = Array.from(dropdown.querySelectorAll('.fsb-search__product, .fsb-search__queries a'));
    if (!items.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeIdx = (activeIdx + 1) % items.length;
      highlight(items);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeIdx = (activeIdx - 1 + items.length) % items.length;
      highlight(items);
    } else if (e.key === 'Enter' && activeIdx >= 0) {
      e.preventDefault();
      const href = items[activeIdx].getAttribute('href');
      if (href) window.location.href = href;
    }
  });
  function highlight(items) {
    items.forEach((el, i) => el.classList.toggle('is-active', i === activeIdx));
    items[activeIdx] && items[activeIdx].scrollIntoView({ block: 'nearest' });
  }

  /* ---------- Helpers ---------- */
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  }
  function formatMoney(price) {
    if (price == null || price === '') return '';
    // Shopify /search/suggest.json returns price as a string already in
    // the shop's main currency unit (e.g. "1500.00" → ₹1500), NOT in
    // paisa. Strip any currency symbol / commas, parse as float, format.
    var num = parseFloat(String(price).replace(/[^\d.-]/g, ''));
    if (isNaN(num)) return '';
    return '₹' + Math.round(num).toLocaleString('en-IN');
  }

  syncClear();
})();